import React, { useState, useEffect, useRef } from "react";
import Navbar2 from "../Header/Navbar2";
import pencil from "../../Assets/img/vector/pencil.png";
import Modal from "react-modal";
import { Button, Table } from "react-bootstrap";

import userimage from "../../Assets/img/authors/profileImage.png";

import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../global";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import DefaultAvatar from "./../../Assets/img/avatar-default.jpeg";

const UserProfile = () => {
    const [isVerified, setIsVerified] = useState(false);
    const [formData, setFormData] = useState([]);

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getUserData",
            pk_user_key: sessionStorage.getItem("pk_user_key"),
        });

        const output = response.data;

        if (output) {
            setFormData(output);
        }
    };

    // const handleImageChange = (e) => {
    //   const file = e.target.files[0];
    //   if (file) {
    //     const reader = new FileReader();
    //     reader.onloadend = () => {
    //       setImage(reader.result);
    //     };
    //     reader.readAsDataURL(file);
    //   }
    // };

    //   const openModal = () => {
    //     setIsModalOpen(true);
    //   };

    //   const closeModal = () => {
    //     setIsModalOpen(false);
    //   };

    //   const handleVerify = () => {
    //     // Add verification logic here
    //     setIsVerified(true);
    //     closeModal();
    //   };

    return (
        <section className="pb-3">
            <div className="container mt-3 ">
                <div className="bread-crup-box">
                    <h3 className="page-title">Profile</h3>
                </div>
                <div className="row">
                    <div className="col-md-12 d-flex justify-content-between align-items-center px-0">
                        <div className="card w-100">
                            <div className="card-body">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="profile-phase-I d-flex">
                                        <label htmlFor="profileImage">
                                            <img
                                                src={formData.profile_mod ? IMAGE_URL + formData.profile_mod : DefaultAvatar}
                                                height={94}
                                                width={94}
                                                alt="Profile"
                                                className="rounded-circle profileimage"
                                                style={{ cursor: "pointer" }}
                                            />
                                        </label>
                                        <div className="name-box p-3">
                                            <h3>{formData.first_name}</h3>
                                            <span className="text-secondary">{formData.country}</span>
                                        </div>
                                    </div>

                                    <div className="btn-grp profile-responsive">
                                        <Button
                                            as={Link}
                                            to="/admin/admin-edit-profile"
                                            className="profile-btn btn btn-dark d-flex align-items-center justify-content-center rounded-2"
                                        >
                                            <img src={pencil} className="pe-1" alt="" />
                                            Edit Profile
                                        </Button>
                                    </div>
                                </div>

                                <div className="row p-3">
                                    <div className="col-md-12 col-lg-6 border-end border-dark border-md-none mb-3">
                                        <h4 className="fw-bold pb-1 mb-2 border-bottom border-dark ">General Information</h4>
                                        <div className="profile-info-home d-flex justify-content-between w-100">
                                            <div className="pro-info-1 d-flex flex-column w-50">
                                                <label className="fw-bold" htmlFor="">
                                                    Superior:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    First Name:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    Last Name:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    Gender:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    DOB:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    Current Level:
                                                </label>
                                                {/* <label className="fw-bold" htmlFor="">
                                                    Joined Date:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    Package Expiry Date:
                                                </label> */}
                                            </div>
                                            <div className="pro-info-2 w-50">
                                                <p className="mb-2">Admin</p>
                                                <p className="mb-2">{formData.first_name}</p>
                                                <p className="mb-2">{formData.last_name}</p>
                                                <p className="mb-2">{formData.gender === 1 ? "Male" : formData.gender === 2 ? "Female" : "Not Specified"}</p>
                                                <p className="mb-2">{formData.dob ? formData.dob : "NA"}</p>
                                                <p className="mb-2">Level-{formData.user_level}</p>
                                                {/* <p className="mb-2">-</p>
                                                <p className="mb-2">-</p> */}
                                                {/* <p className="mb-2">2024-02-02 07:30:05</p>
                                                <p className="mb-2">2024-03-02 07:30:05</p> */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-12 col-lg-6">
                                        <h4 className="fw-bold pb-1 mb-2 border-bottom border-dark">Contact Information</h4>
                                        <div className="profile-info-home d-flex justify-content-between align-items-start w-100">
                                            <div className="pro-info-1 d-flex flex-column w-50">
                                                <label className="fw-bold" htmlFor="">
                                                    Email:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    Phone:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    Address Line1:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    Address Line2:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    Country:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    State:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    City:
                                                </label>
                                                <label className="fw-bold" htmlFor="">
                                                    Zip Code:
                                                </label>
                                            </div>
                                            <div className="pro-info-2 w-50">
                                                <p className="mb-2">{formData.user_email} </p>
                                                <p className="mb-2">{formData.phone} </p>
                                                <p className="mb-2">{formData.address_line1 ? formData.address_line1 : "NA"} </p>
                                                <p className="mb-2">{formData.address_line2 ? formData.address_line2 : "NA"}</p>
                                                <p className="mb-2">{formData.city ? formData.city : "NA"} </p>
                                                <p className="mb-2">{formData.state ? formData.state : "NA"} </p>
                                                <p className="mb-2">{formData.country ? formData.country : "NA"} </p>
                                                <p className="mb-2">{formData.zip_code ? formData.zip_code : "NA"} </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="col-md-12 col-lg-6 mt-3">
                                        <h5 className="fw-bold pb-1 mb-2 border-bottom border-dark">Payment Details</h5>
                                        <p className="d-none">Payment Type: {formData.paymentType}</p>
                                        <div className="profile-info-home d-flex justify-content-between align-items-start w-100">
                                            <div className="pro-info-1 d-flex flex-column w-50">
                                                <label className="fw-bold">Payment Type:</label>
                                                {formData.paymentType === "bank" && (
                                                    <>
                                                        <label className="fw-bold">Holder Name:</label>
                                                        <label className="fw-bold">Bank Name:</label>
                                                        <label className="fw-bold">Account Number:</label>
                                                    </>
                                                )}
                                                {formData.paymentType === "paypal" && <label className="fw-bold">PayPal ID:</label>}
                                                <label className="fw-bold">Verification:</label>
                                            </div>

                                            <div className="pro-info-2 w-50">
                                                <p className="mb-2">{formData.paymentType}</p>
                                                {formData.paymentType === "bank" && (
                                                    <>
                                                        <p className="mb-2">{""}</p>
                                                        <p className="mb-2">{""}</p>
                                                        <p className="mb-2">{""}</p>
                                                    </>
                                                )}
                                                {formData.paymentType === "paypal" && <p className="mb-2">{""}</p>}
                                                <p className="mb-2">{"-"}</p>
                                                <p className="mb-2">{isVerified ? "Verified" : "Verified"}</p>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>
                {`
                    .Modal {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        padding: 20px;
                        max-width: 500px;
                        width: 100%;
                        background: white;
                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
                        border-radius: 8px;
                    }

                    .Overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                `}
            </style>
        </section>
    );
};

export default UserProfile;
